import { render } from "./GalerieFullDetail.vue?vue&type=template&id=23d27450"
import script from "./GalerieFullDetail.vue?vue&type=script&lang=js"
export * from "./GalerieFullDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__